import * as types from './types';
import { activeRequests, addActiveRequest, deleteActiveRequest } from '../../utils/network';
import { AGENT_SERVICE_ENDPOINT_URL, VOUCHERS_PAGE_SIZE } from '../../constants/defaultValues';
import AgentService from '../../services/AgentService';
import { printVoucher } from './betSlip';
import { showErrorNotification } from '../../utils/render';
import API from '../../utils/api';
import { getUserAccount } from './user';
import { VOUCHER_STATUSES } from '../../constants/enums';
import { changeErrorModalProps, resetErrorModalProps } from './global';

export const getVouchers = filters => async (dispatch, getState) => {
    try {
        const { status, period, pageOffset } = filters;
        const { startTime: startDate, endTime: endDate } = period.getRange();

        if (!startDate || !endDate) {
            return;
        }

        const timestamp = new Date().getTime();
        const activeRequestKey = 'agent/vouchers';
        deleteActiveRequest(activeRequestKey);
        addActiveRequest(activeRequestKey, timestamp);

        dispatch({
            type: types.GET_VOUCHERS_REQUEST,
        });

        const params = {
            status,
            startDate,
            endDate,
            pageSize: VOUCHERS_PAGE_SIZE,
            pageIndex: pageOffset,
        };

        const { info, items } = await AgentService.getVouchers(params);

        if (info.success) {
            const activeRequestTimestamp = activeRequests[activeRequestKey];

            if (timestamp !== activeRequestTimestamp) return;

            const reduxStore = getState();
            const vouchers = reduxStore.vouchers.data;
            const newVouchers = pageOffset === 0 ? items : vouchers.concat(items);

            dispatch({
                type: types.GET_VOUCHERS_SUCCESS,
                payload: newVouchers,
                hasMore: items.length >= VOUCHERS_PAGE_SIZE,
            });
        }
    } catch (error) {
        console.error({ error });
    }
};

export const clearVouchers = () => ({ type: types.CLEAR_VOUCHERS });

export const createVoucher = data => async () => {
    try {
        const { info, item } = await AgentService.createVoucher(data);

        if (!info.success) {
            showErrorNotification(info.errors[0]?.reason);
        }

        const printData = {
            ...item,
            code: item.code,
        };

        await printVoucher(printData);

        return info;
    } catch (err) {
        console.log(err);
        showErrorNotification(err.response?.data.info.errors[0]?.reason || 'Something went wrong');

        return {
            info: {
                success: false,
            },
        };
    }
};

export const sendVoucherReprintRequest = voucherCode => async () => {
    try {
        const { info, item } = await AgentService.reprintVoucher(voucherCode);

        if (!info.success) {
            showErrorNotification(info.errors[0].reason || 'Something went wrong');
            return;
        }

        return item;
    } catch (error) {
        showErrorNotification(
            error.response?.data?.info?.errors[0].reason || 'Something went wrong'
        );
    }
};

export const reprintVoucher = voucherCode => async dispatch => {
    try {
        const { info, item } = await AgentService.printVoucher(voucherCode);

        if (!info.success) {
            showErrorNotification(info.errors[0].reason || 'Something went wrong');
            return;
        }

        const reprintData = {
            ...item,
            isReprint: true,
            isCancelled: item.status === VOUCHER_STATUSES.cancelled,
        };

        dispatch(
            changeVoucherModalProps({
                voucher: item,
            })
        );

        await printVoucher(reprintData);
    } catch (error) {
        showErrorNotification(
            error.response?.data?.info?.errors[0].reason || 'Something went wrong'
        );
    }
};

export const getVoucher = voucherCode => async dispatch => {
    dispatch(resetErrorModalProps());
    dispatch(changeVoucherModalProps({ loading: true }));

    try {
        const { info, item } = await AgentService.getVoucher(voucherCode);

        if (info.success) {
            dispatch(changeVoucherModalProps({ loading: false, voucher: item }));
            // dispatch(resetErrorModalProps());
            return item;
        }
    } catch (error) {
        const { info } = error.response.data;
        dispatch(resetVoucherModalProps());
        dispatch(changeErrorModalProps({ isVisible: true, errors: info.errors }));

        showErrorNotification(info?.errors[0].reason || 'Something went wrong');
    }
};

export const cancelVoucher = voucherId => async (dispatch, getState) => {
    const store = getState();

    const vouchers = store.vouchers.data;

    dispatch({
        type: types.CANCEL_VOUCHER_REQUEST,
        payload: { loading: true, error: null },
    });

    try {
        const res = await API.patch(`${AGENT_SERVICE_ENDPOINT_URL}/vouchers/${voucherId}`);
        const { info, item } = res.data;

        if (info.success) {
            dispatch(getUserAccount());
            dispatch(
                changeVoucherModalProps({
                    voucher: item,
                })
            );
            dispatch(
                setVouchers(
                    vouchers.map(voucher => {
                        if (voucher.id === voucherId)
                            return { ...voucher, status: VOUCHER_STATUSES.cancelled };
                        return voucher;
                    })
                )
            );
            dispatch({
                type: types.CANCEL_VOUCHER_REQUEST,
                payload: { loading: false, error: null },
            });

            return item;
        }
    } catch (err) {
        const { info } = err.response.data;
        dispatch({
            type: types.CANCEL_VOUCHER_REQUEST,
            payload: { loading: false, error: info },
        });
    }
};

export const setVouchers = data => ({
    type: types.SET_VOUCHERS,
    payload: data,
});

export const clearVoucher = () => ({
    type: types.CLEAR_VOUCHER,
});

export const changeVoucherModalProps = payload => ({
    type: types.VOUCHER_MODAL_PROPS_CHANGED,
    payload,
});

export const resetVoucherModalProps = payload => ({
    type: types.VOUCHER_MODAL_PROPS_RESET,
    payload,
});
